
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grievances",
      function () {
        return require("private-next-pages/grievances/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grievances"])
      });
    }
  